export default __webpack_public_path__ + "static/media/squeakersnft_logo.44fc9d47.gif";